<pannel [title]="'Validation et signature du document'">

  <p>En signant ce document, les signataires attestent :</p>
	<ul>
	  <li>Avoir lu et pris connaissance du présent document et de ses annexes</li>
	  <li>Qu’ils mettront en œuvre les consignes et mesures de sécurité inhérentes à ce document</li>
	  <li>
	    <b>
	      Pour l’EE : qu’il signalera au besoin à l’EU les mesures complémentaires nécessaires
	      à son intervention (nouvelle tâche, nouveau risque, nouvel équipement, …)
	    </b>
	  </li>
	</ul>

	<div class="align-text">
		<b>
		  De plus, en tant que représentant de l’EE, le signataire de l’EE s’engage à transmettre
		  et présenter à ses équipes les risques, mesures de sécurité et annexes exposées
		  dans le présent document.
		</b>
	</div>
	
	<pannel [title]="'Signataires (valideurs et représentants)'">

    <!-- ================= EU ================= -->
    <p class="emargement-header-cell">Entreprise utilisatrice (EU)</p>

    <table class="mat-table signataires-table" *ngIf="euEeData">
      <tr class="mat-header-row">
        <th class="mat-header-cell">Nom / Prénom du signataire</th>
        <th class="mat-header-cell">Entreprise *</th>
        <th class="mat-header-cell">Raison sociale</th>
        <th class="mat-header-cell">Email</th>
        <th class="mat-header-cell">Fonction du signataire</th>
        <th class="mat-header-cell"></th>
      </tr>

      <tr class="mat-row">
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.nomPrenomResponsableEu" readonly />
        </td>
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.raisonSocialeEu" readonly />
        </td>
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.raisonSocialeEu" readonly />
        </td>
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.emailResponsableEu" readonly/>
        </td>
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.fonctionResponsableEu" maxlength="255" readonly />
        </td>
        <td class="mat-cell"></td>
      </tr>
    </table>

    <!-- ================= EE ================= -->
    <p class="emargement-header-cell">Entreprise exécutante (EE)</p>
    <table class="mat-table signataires-table" *ngIf="euEeData">
      <tr class="mat-header-row">
        <th class="mat-header-cell">Nom / Prénom du signataire</th>
        <th class="mat-header-cell">Entreprise *</th>
        <th class="mat-header-cell">Raison sociale</th>
        <th class="mat-header-cell">Email</th>
        <th class="mat-header-cell">Fonction du signataire</th>
        <th class="mat-header-cell">Intervenant</th>
      </tr>

      <tr class="mat-row">
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.nomPrenomResponsableEe" readonly />
        </td>
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.raisonSocialeEe" readonly />
        </td>
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.raisonSocialeEe" readonly />
        </td>
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.emailResponsableEe" readonly />
        </td>
        <td class="mat-cell">
          <input class="form-control" [(ngModel)]="euEeData.fonctionResponsableEe" maxlength="255" readonly />
        </td>
		<td class="mat-cell">
		    <input type="checkbox" [(ngModel)]="eeIsIntervenant" (change)="eeIsIntervenantChange()"/>
		</td>
      </tr>
    </table>
  </pannel>
  
  <pannel [title]="'Liste des intervenants'">
  	<ng-container [ngTemplateOutlet]="blocSignatairesOuIntervenants"></ng-container>
  </pannel>
</pannel>

<document-pa-step-actions [documentPaButtons]="actionButtons" (onButtonPressed)="performAction($event)"></document-pa-step-actions>

<signataire-dialog [id]="signataireDialogId" [initCommands]="gererIntervenantsCommands" (signatairesSelected)="onIntervenantsSelected($event)"></signataire-dialog>

<pa-generation [id]="generationPaDialogId" [generationCommands]="generationCommands"></pa-generation>
		
<ng-template #blocSignatairesOuIntervenants>
        <div style="display: inline-flex">
            <button
			    type="button"
			    class="btn btn-primary"
			    (click)="openDialogIntervenants()">

            	Ajouter Intervenant
            </button>
			<select class="form-control entreprise-filter" [(ngModel)]="selectedEntrepriseForIntervenantDialog">
			    <option [ngValue]="null"></option>
			    <option *ngFor="let entreprise of entreprises" [ngValue]="entreprise">{{entreprise.nom}}</option>
			</select>
        </div>
        <table mat-table class="signataires-table" [dataSource]="signataires">
            <!-- Nom -->
            <ng-container matColumnDef="nom">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Nom</th>
                <td mat-cell *matCellDef="let signataire">
                    {{signataire.nom}}
                </td>
            </ng-container>
            <!-- Prénom -->
            <ng-container matColumnDef="prenom">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Prénom</th>
                <td mat-cell *matCellDef="let signataire">
                    {{signataire.prenom}}
                </td>
            </ng-container>
            <!-- Entreprise -->
            <ng-container matColumnDef="entreprise">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Entreprise</th>
                <td mat-cell *matCellDef="let signataire">
                    {{signataire.nomEntreprise}}
                </td>
            </ng-container>
            <ng-container matColumnDef="raisonSociale">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Raison Sociale</th>
                <td mat-cell *matCellDef="let signataire">
                    {{signataire.raisonSociale}}
                </td>
            </ng-container>
		    <!-- Email -->
		    <ng-container matColumnDef="email">
		        <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Email</th>
		        <td mat-cell *matCellDef="let signataire">
		            <input id="emailSignataire" name="emailSignataire" class="form-control {{ signataire.emailStyle }}" [(ngModel)]="signataire.email" >
		        </td>
		    </ng-container>
            <!-- Fonction -->
            <ng-container matColumnDef="fonction">
                <th mat-header-cell class="emargement-header-cell" *matHeaderCellDef>Fonction</th>
                <td mat-cell *matCellDef="let signataire">
                    <input id="fonctionSignataire" name="fonctionSignataire" class="form-control" [(ngModel)]="signataire.fonction" >
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsSignataires"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsSignataires"></tr>
        </table>
</ng-template>
